export default __webpack_public_path__ + "static/media/SAS0230.34I-37953_-22211_0.58541307.jpg";